/** @jsxFrag React.Fragment */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/cds-core';

import { DISCLAIMER_LINKS } from 'bundles/payments-common/common/constants';

import _t from 'i18n!nls/payments';

const styles = {
  underlinedLink: css`
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  `,
};

export const getTermsOfUseLink = (label?: string) => (
  <Link href={DISCLAIMER_LINKS.TERMS_OF_USE} target="_blank" rel="noopener">
    {label ?? _t('Terms of Use')}
  </Link>
);

export const getRefundPolicyLink = (label?: string) => (
  <Link href={DISCLAIMER_LINKS.REFUND_POLICY} target="_blank" rel="noopener">
    {label ?? _t('Refund Policy')}
  </Link>
);

export const getPrivacyPolicy = (label?: string) => (
  <Link href={DISCLAIMER_LINKS.PRIVACY_POLICY} target="_blank" rel="noopener">
    {label ?? _t('Privacy Policy')}
  </Link>
);

type CancelLinkInputType = {
  label?: string;
};

export const getCancelSubscriptionLink = (input?: CancelLinkInputType) => {
  const { label } = input || {};
  return (
    <Link href={DISCLAIMER_LINKS.CANCEL_SUBSCRIPTION} target="_blank" rel="noopener noreferrer">
      <span css={styles.underlinedLink}>{label ?? _t('cancel')}</span>
    </Link>
  );
};
